import { ActionIcon } from "@mantine/core";
import { IconHelp } from "@tabler/icons-react";
import { useScribeModal } from "shared/components/global/Scribe/useScribeModal";

export const ScribeIcon = ({ src }: { src: string }) => {
    const scribe = useScribeModal({ src });

    return (
        <ActionIcon
            variant="transparent"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                scribe.present();
            }}
        >
            <IconHelp size={16} />
        </ActionIcon>
    );
};
